type IFrameProps = {
  width?: string;
  height?: string;
  srcDoc: string;
  styleCode?: string;
};

const IFrame = ({ width = "100%", height = "100rem", srcDoc }: IFrameProps) => {
  return <iframe width={width} height={height} srcDoc={srcDoc} />;
};

export default IFrame;
